import { NativeStackHeaderProps } from '@react-navigation/native-stack';
import { Stack, useGlobalSearchParams } from 'expo-router';
import React, { useLayoutEffect } from 'react';

import { AuthRouteBaseProvider, persistOAuthRedirectFromSearchParams } from '@fhs/auth';
import { MqSwitch, tokens } from '@fhs/ui';

import { AppHeader } from '../../components/app-header';
import { AppHeaderRightDesktop } from '../../components/app-header/app-header-desktop';
import {
  AuthHeaderLeft,
  AuthHeaderMiddle,
} from '../../components/app-header/auth-header/auth-header-mobile';

const routeNamesMap = {
  index: 'Log In or Sign Up',
  'verify/index': 'Verify With Code',
  'continuewithemail/index': 'Continue With Email',
  'signup/index': 'Create an Account',
};

function header(props: NativeStackHeaderProps) {
  return (
    <MqSwitch
      $base={() => <AppHeader right={<AppHeaderRightDesktop isAuthRoute />} />}
      $ltDesktop={() => (
        <AppHeader
          left={<AuthHeaderLeft />}
          middle={<AuthHeaderMiddle title={routeNamesMap[props.route.name]} />}
          right={null}
        />
      )}
    />
  );
}

function AuthOAuthRedirectCapture() {
  const params = useGlobalSearchParams<{
    redirect_uri?: string | string[];
    state?: string | string[];
  }>();
  useLayoutEffect(() => {
    persistOAuthRedirectFromSearchParams(params.redirect_uri, params.state);
  }, [params.redirect_uri, params.state]);
  return null;
}

export default function OAuthAuthLayout() {
  return (
    <AuthRouteBaseProvider basePath="/auth">
      <AuthOAuthRedirectCapture />
      <Stack
        initialRouteName={'index'}
        screenOptions={{
          header,
          contentStyle: { backgroundColor: tokens.colors.$white },
        }}
      >
        <Stack.Screen name="index" />
        <Stack.Screen name="signup" />
        <Stack.Screen name="continuewithemail" />
        <Stack.Screen name="verify" />
      </Stack>
    </AuthRouteBaseProvider>
  );
}
